import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Box,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  useColorModeValue,
  Text,
  Img,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import CenteredAuth from 'layouts/auth/types/Centered';
import CInput from 'components/CInput';
import CButton from 'components/CButton';

function Login() {
  const { auth, login } = useAuth();

  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const textColorBrand = useColorModeValue('brand.500', 'white');

  const [validated, setValidated] = useState(false);
  const [credential, setCredential] = useState({
    email: "",
    password: ""
  });

  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidated(true);

    if (!credential.email || !credential.password || credential.password.length < 8) return;

    try {
      await login(credential);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.token) {
      if (location.pathname !== '/login') {
        navigate(location.pathname);
      } else if (auth.user.role === "admin" || auth.user.role === "receptionist" || auth.user.role === "trainer") {
        navigate('/admin/dashboard/overview');
      }
    }
  }, [auth?.token, navigate, location.pathname]);


  return (
    <CenteredAuth
      cardTop={{ base: '140px', md: '12vh' }}
      cardBottom={{ base: '50px', lg: 'auto' }}
      mx="0px"
    >
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        justifyContent="center"
        px={{ base: '20px', md: '0px' }}
        flexDirection="column"
      >
        <Flex
          flexDirection="column"
          justifyContent="center"
          w={{ base: '100%', md: '420px' }}
        >
          <Img
            src='/logo8.png'
            h='auto'
            w="215px"
            px='20px'
            mb="52px"
            alignSelf="center"
          />
        </Flex>
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Sign In
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Enter your email and password to sign in!
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: '100%', md: '420px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
        >
          <form onSubmit={handleSubmit}>
            <CInput
              label="Email"
              type="text"
              value={credential.email}
              onChange={(value) => setCredential({ ...credential, email: value })}
              required={true}
              validated={validated}
              errorMessage="Email is required."
              placeholder="mail@sample.com"
            />
            <CInput
              label="Password"
              type="password"
              value={credential.password}
              onChange={(value) => setCredential({ ...credential, password: value })}
              required={true}
              validated={validated}
              validationRules={{ minLength: 8 }}
              placeholder="Min. 8 characters"
            />
            <Flex justifyContent="end" align="center" mb="24px">
              <NavLink to="/forgot-password">
                <Text
                  fontSize="sm"
                  w="124px"
                  fontWeight="500"
                  color='#fa8f03'
                >
                  Forgot password?
                </Text>
              </NavLink>
            </Flex>
            <CButton
              mb="24px"
              type="submit"
            >
              Sign In
            </CButton>
          </form>
        </Flex>
      </Flex>
    </CenteredAuth>
  );
}

export default Login;

